import styles from "./styles/SisSyncTab.module.scss";
import {useStores} from "../../stores/useStores";
import {useFeatureFlags} from "../../utils/featureFlags/useFeatureFlags";

export function SisSyncTab() {
    const {organizationStore} = useStores();
    const {show_two_way_messaging} = useFeatureFlags();

    return <div>
        <div className="sb-settings-block-content-heading">
            <h4>Sync SIS Roster Data with SchoolBlocks</h4>
        </div>
        <div>
            SIS Roster Data syncing is currently <span style={{fontWeight: 700}}>
            {organizationStore.organization.oneroster_id ? "Enabled" : "Disabled"}
        </span>. {!!organizationStore.organization.oneroster_id || "Please contact support to enable."}
        </div>
        <div className={styles.content}>
            <h5>SIS Syncing offers the following benefits:</h5>
            <ul>
                <li>
                    <h6>Fine-tuned Messaging Support</h6>
                    <p>SchoolBlocks provides both internal and external messaging channels. Adding SIS integration kicks
                        this service into overdrive by allowing you to communicate with school teachers, staff,
                        students, and guardians either directly or by creating custom lists.</p>
                </li>
                <li>
                    <h6>Guardian Syncing</h6>
                    {show_two_way_messaging ?
                        <p>SIS integration adds support for syncing student-guardian information. This can be used for
                            both contacting guardians directly, or providing parents and guardians the ability to
                            contact their students' teachers without leaving the website.</p> :
                        <p>SIS integration adds support for syncing student-guardian information which can be used for
                            contacting guardians directly.</p>}
                </li>
                <li>
                    <h6>Classroom Content Feeds</h6>
                    <p>Students are auto-subscribed to the classroom pages they are enrolled in. When content is posted
                        to those classroom pages, it will automatically appear in students' personalized feeds.</p>
                </li>
            </ul>
        </div>
    </div>
}